;(function() {
	var pageFlag = $('#mylgProductPageType').val() != '' && $('#mylgProductPageType').val() != undefined && $('#mylgProductPageType').val() == 'ocr'; //PJTERAP-1
	var registerFlag = $('#mylgProductRegisterFlag').val() != '' && $('#mylgProductRegisterFlag').val() != undefined && $('#mylgProductRegisterFlag').val() == 'register'; //PJTERAP-1
	
	var $inputArea = $('.register-input'),
		$listArea = $('.register-add-result'),
		$proccessingArea = $('.register-processing'),

		productType = $('#productType').length ? $('#productType').val() : 'b2c';

	function productListInit() {
		var $editArea = $('.register-input .select-product-area'),
			$resultArea = $('.register-add-result'),
			$button = $('.register-add .btn-add'),
			template = $('.select-product-template').clone().html(),
			index = 0;

		$('.select-product-template').remove();
		// 200409 START 전호근 - datepicker / input:file 오류 수정
		$editArea.find("#file").length && $editArea.find("#file").fileUploadSet(); //LGECI-687
		var addEventHandler = function() {
			
			var $productlist = $resultArea.find('.product-list');

			if ($editArea.find('.option-form').checkValidation({trigger:true})) {
				var $listItem, $fileArea, $listView,
					$tempItem = $(template);
				
				var dataArr = $.merge($editArea.find('.comboboxForm').serializeArray(), $editArea.find('.option-form').serializeArray()),
					imgUrl =  $editArea.find('.model-image').attr('src'),
					inputVal = $editArea.find('.search-common-input').val(),
					data = {};
					
					/* PJTERAP-1 Start */
					var linkUrl;
					if(pageFlag) linkUrl = $editArea.find('.pd-list-num').closest('a').attr('href');
					else linkUrl = $editArea.find('.model-link').attr('href');
					/* PJTERAP-1 End */

				var attrChange = function($temp, property) {
					$temp.find('[' + property + ']').each(function() {
						var value = $(this).prop(property);
	
						$(this).prop(property, value + '_' + index);
					});					

					return $temp;
				}

				$.each(dataArr, function() {
					data[this.name] = this.value;
				});
				data.imgUrl = imgUrl;
				data.modelName = inputVal;
				
				$tempItem = $tempItem.attr('data-index', index);
				$listItem = $productlist.append($tempItem).find('[data-index="' + index + '"]');
				
				if ($editArea.find('input[type="file"]')[0].files.length) {
					data['file'] = $editArea.find('input[type="file"]')[0].files[0];
					var $fileArea = $editArea.find('.delivery-part').parent().children().clone(true);
					$listItem.find('.delivery-part').parent().html($fileArea);
				} else {
					bindFileUpload();
				}
				
				$listItem = attrChange($listItem, 'id');
				$listItem = attrChange($listItem, 'for');
				$listView = $listItem.find('.product-list-view');
				$listView.find('.image img').attr('src', imgUrl);
				$listView.find('.name .link-text').attr('href', linkUrl);
				$listView.find('.name .link-text').html(data.modelNumber);
				$listView.find('.serial-number').html(data.serialNumber);

				$listItem.data('option', data); 
				$listItem.find('.js-scroll').mCustomScrollbar({
					theme:'dark',
					mouseWheelPixels:120
				});
				$listItem.find('.select-product-area').data('pluginJsModel', new Model($listItem.find('.select-product-area')[0]));
				$editArea.data('pluginJsModel').reset();
				$editArea.data('pluginJsModel').optionReset();

				$editArea.find('.option-form').find('input[type="text"], input[type="file"], button').prop('disabled', true);
				$editArea.find('.option-form').find('input[type="text"], input[type="file"], button').attr('disabled', 'disabled');
				
				index++;

				searchInit();
				runChosen();
				initDatePicker();
				
				!$resultArea.is(':visible') && $resultArea.show();
				$resultArea.find('.product-list-edit').hide().removeClass('active');
				$resultArea.find('[data-button="edit"]').text($resultArea.find('[data-button="edit"]').data('openText'));
				$productlist.find('.product-list-item').length == 5 && $button.prop('disabled', true);
				$('html, body').stop().animate({
					'scrollTop' : $resultArea.offset().top
				});
			}
		}
		var deleteEventHandler = function() {
			var $item = $(this).closest('.product-list-item'),
				len = 0;

			$item.remove();

			len = $resultArea.find('.product-list-item').length;

			if (len == 0) {
				$resultArea.hide();
			} else if (len <= 4 && $button.prop('disabled')) {
				$button.prop('disabled', false);
			}
		}
		var editEventHandler = function(e) {
			var $button = $(this),
				$item = $button.closest('.product-list-item'),
				$edit = $item.find('.product-list-edit'),
				data = $item.data('option'),
				$model = $item.find('.select-product-area');
			
			if (!$edit.hasClass('active')) {
				$item.siblings().find('.product-list-edit').stop().slideUp();
				$item.siblings().find('[data-button="edit"]').text($item.siblings().find('[data-button="edit"]').data('openText'));
				$edit.stop().slideDown();
				$edit.addClass('active');
				$button.text($button.data('closeText'));

				if (data.file) {
					var $fileArea = $edit.find('.delivery-part').parent().children().clone(true);
				}

				var callback = function() {
					for (var key in data) {
						$edit.find('[name="' + key + '"]').val(data[key]);
					}
					$edit.find('.search-common-input').val(data.modelName);
					$edit.find('.delivery-part').parent().html($fileArea);
					// 200319 START 전호근 - BR datepicker 적용
					$edit.find('[data-provide="datepicker"]').each(function() {
						var $this = $(this);
						$this.datePicker('setDate', $this.val());
					});
					// 200319 END 전호근 - BR datepicker 적용
				}

				$item.find('.select-product-area').data('pluginJsModel').pasteModelInfo(data.modelNumber, $model.find('.search-common')[0].action, $model.find('.search-common').data('param') + "=" + data.modelNumber, callback);
			} else {
				$edit.stop().slideUp();
				$edit.removeClass('active');
				$button.text($button.data('openText'));
			}

			e.preventDefault();
		}
		// 200409 END 전호근 - datepicker / input:file 오류 수정
		var modifyEventHandler = function(e) {
			e.preventDefault();

			var $button = $(this),
				$item = $button.closest('.product-list-item'),
				$view = $item.find('.product-list-view'),
				$edit = $item.find('.product-list-edit'),
				dataArr = $.merge($edit.find('.comboboxForm').serializeArray(), $edit.find('.option-form').serializeArray()),
				data = {};

				if ($edit.find('.option-form').checkValidation({trigger:true})) {
					$.each(dataArr, function() {
						data[this.name] = this.value;
					});

					data.modelName = $edit.find('.search-common-input').val();
					data.imgUrl = $edit.find('.model-image').attr('src');
					
					if ($edit.find('input[type="file"]')[0].files.length) {
						data['file'] = $edit.find('input[type="file"]')[0].files[0];
					} else {
						delete data['file'];
					}

					$view.find('.image img').attr('src', $edit.find('.model-view-image').find('img').attr('src'));
					$view.find('.name .link-text').attr('href', $edit.find('.model-view-image').find('.model-link').attr('href'));
					$view.find('.name .link-text').text(data.modelNumber);
					$view.find('.serial-number').text(data.serialNumber);

					$item.data('option', data);

					$edit.stop().slideUp();
					$edit.removeClass('active');
					$view.find('[data-button="edit"]').text($view.find('[data-button="edit"]').data('openText'));

					$('html, body').stop().animate({
						'scrollTop' : $resultArea.offset().top
					});
				}
		};

		$(document).on('click', '[data-button="delete"]', deleteEventHandler);
		$(document).on('click', '[data-button="edit"]', editEventHandler);
		$(document).on('click', '.product-list-item .btn-area button', modifyEventHandler);
		$button.on('click', addEventHandler);
	}
	function productSpaceInit() {
		//PJTEXTENDEDWTY-4
		if($('#receiveObsYnAlert').length > 0 ){
			$('#receiveObsYnAlert').modal('show');
		}
		//PJTEXTENDEDWTY-4
		var $radio = $('.check-list').find('input[type="radio"]'),
			$type = $('#productType'),
			$modal = $('#warningAlert'),
			$space = $('.register-input .select-product-area');
			$ocrB2bLink = $('.link-business');

		if ($radio.length != 0) {
			var areaChange = function(type) {
				var $showArea = $('[data-type="' + type + '"]'),
					$hideArea = null;

				if (type == 'b2b') {
					$hideArea = $('[data-type="b2c"]'); 
				} else {
					$hideArea = $('[data-type="b2b"]');
					$('.register-add-result').hide();
					$('.register-add-result').find('.product-list-item').remove();
				}

				$('[data-required-type]').each(function() {
					var $this = $(this),
						requiredFlag = $this.attr('data-required-type') === type;

					$this.find('.require').toggle(requiredFlag);	
					$this.find(':input').prop('required', requiredFlag);
				});

				productType = type;
				$showArea.show();
				$hideArea.hide();
				$space.data('pluginJsModel').reset();
				$space.data('pluginJsModel').optionReset();
	
				$('.option-form').find('input[type="text"], input[type="file"], button').prop('disabled', true);
				$('.option-form').find('input[type="text"], input[type="file"], button').attr('disabled', 'disabled');
			}

			var radioClickEventHandler = function(e) {
				var type = $(this).data('option'),
					url = '',
					companyFlag = false,
					$input = $space.find('.modelNumber_hidden');


				if (type == 'b2b') {
					$.ajax({
						url: $(this).data('url'),
						type: 'post',
						async: false,
						dataType: 'json',
						beforeSend: function() {
							$('body').trigger('ajaxLoadBefore');
						},
						success: function(data) {
							if (data) {
								if (!data.companyFlag) {
									e.preventDefault();

									url = data.url;
								}
								companyFlag = data.companyFlag;
							}
							$('body').trigger('ajaxLoadEnd');
						}
					});

					if (!companyFlag) {
						location.href = url;
						return false;
					}
				}

				if ($.trim($input.val()) || $('.register-add-result').find('.product-list-item').length > 0) {
					$modal.modal('show');
					$modal.data('type', type);

					e.preventDefault();
				} else {
					areaChange(type);
				}
			}
			
			var confirmClickEventHandler = function(e) {
				e.preventDefault();

				areaChange($modal.data('type'));
				$radio.filter('[data-option="'+ $modal.data('type') +'"]').prop('checked', true).trigger('change');
				$modal.modal('hide');
			}

			$modal.find('button[type="submit"]').on('click', confirmClickEventHandler);
			$radio.on('click', radioClickEventHandler);
		} else {
			var type = $type.val(),
				$showArea = $('[data-type="' + type + '"]');

			if (type == 'b2b') {
				$hideArea = $('[data-type="b2c"]'); 
			} else {
				$hideArea = $('[data-type="b2b"]');
			}
			$hideArea.hide();
			$showArea.show();
		}
		
		/* PJTERAP-1 Start */
		if($ocrB2bLink.length){
			var ocrBusinessClickEventHandler = function(e) {
				e.preventDefault();
				
				var url = '',
				companyFlag = false;

				$.ajax({
					url: $(this).data('url'),
					type: 'post',
					async: false,
					dataType: 'json',
					
					success: function(data) {
						if (data) {
							if (!data.companyFlag) {
								e.preventDefault();

								url = data.url;
							}
							companyFlag = data.companyFlag;
						}
					}
				});

				if (!companyFlag) {
					location.href = url;
					return false;
				}else{
					location.href = $(this).attr('href');
				}
				e.stopPropagation();
			}
			
			$ocrB2bLink.find('a').on('click', ocrBusinessClickEventHandler);
		}
		/* PJTERAP-1 End */
	}
	function eventhandler() {
		var isRun = false;

		$('[data-button="save"]').on('click', function(e) {
			
			if(pageFlag) e.preventDefault(); //PJTERAP-1
			
			if (isRun == true) {
				return;
			}

			isRun = true;
			
			var $optionForm = $inputArea.find('.option-form'),
				$listItem = $listArea.find('.product-list-item'),
				checkFlag = false,
				submitArr = [],
				paramArr = [],
				param = [],
				tempParam = {};
			
			/* PJTERAP-1 Start, ocr 제품등록 페이지  */
			if(pageFlag){
				var $tab_id = $('.ocr-tab a.active').attr('href');
				$optionForm = $($tab_id).find('.option-form');
			}
			/* PJTERAP-1 End */
			
			var submitHandler = function(index) {
				//e.preventDefault();
				
				var formData = new FormData(),
					item = param[index];

				for (var key in item) {
					formData.append(key, item[key]);
				}
				
				// LGEAU-558
				if (COUNTRY_CODE == 'au' && document.querySelector('.signup-wrap')) {
					// LGEITF-491 start
					if( $("#txtBoxVerificationCode").length > 0){
						formData.append('verificationCode', $("#txtBoxVerificationCode").val());
					}
					// LGEITF-491 end
					// PJTGPEMP-21 start
					if( $("input[name=empUseFlag]").length > 0 && $("input[name=empUseFlag]").val() == "Y"){
						var chked_val = "";
						$("input[name*='policy_name_list']:checked").each(function(pi,po) {
							chked_val += ","+po.value;
						});
						if(chked_val!="") chked_val = chked_val.substring(1);
						formData.append('withProductPolicyNameList', chked_val);
					}
					// PJTGPEMP-21 end
				}
				// LGEAU-558 End
				
				formData.append('productType' ,productType);
				// LGEGMC-4167 Start
				if($('#addThinQinfo').val() === 'Y'){
					formData.append('addThinQinfo', $('#addThinQinfo').val());
					formData.append('thinqDeviceId', $('#thinqDeviceId').val());
					formData.append('thinqRegDate', $('#thinqRegDate').val());
				}
				// LGEGMC-4167 End
				
				// LGECI-59 start
				if( param[0].noLogin == "Y"){
					var formValidateResult = $('#caForm').checkValidation({trigger:true});
					
					if(formValidateResult) {
						// LGECI-541 start
						if(document.getElementById('customizedCaptcha') ==  null || document.getElementById('customizedCaptcha') == undefined ){
							if( !!$('#g-sitekey').val() && $("#useNewCaptchaView").val() == "N"){
								var reCaptcha_Key = $('#g-sitekey').val();
					        	grecaptcha.enterprise.ready(function() {
					        		grecaptcha.enterprise.execute(reCaptcha_Key, {action: $("#recaptchaPageType").val()}).then(function(token) {
					        			$("#g-recaptcha").val(btoa(token));
					        			var caformJson = $("#caForm").serializeArray();
										
										$.each(caformJson,function(key,value) {
											formData.append(caformJson[key].name,caformJson[key].value);
										});
										
										formSubmit();
					        		});
					        	});
							}else if( !!$('#g-recaptcha').val() && $("#useNewCaptchaView").val() == "Y"){
								var caformJson = $("#caForm").serializeArray();
								
								$.each(caformJson,function(key,value) {
									formData.append(caformJson[key].name,caformJson[key].value);
								});
								
								formSubmit();
							}else{
								$('body').trigger('ajaxLoadEnd');
								isRun = false;
							}
						}// LGECI-541 end
						else if(captcha.validation() != false) {
							var caformJson = $("#caForm").serializeArray();
							
							$.each(caformJson,function(key,value) {
								formData.append(caformJson[key].name,caformJson[key].value);
							});
							
							formSubmit();
						}else{
							$('body').trigger('ajaxLoadEnd');
							isRun = false;
							//e.preventDefault();
						}
					}else{
						$('body').trigger('ajaxLoadEnd');
						isRun = false;
					//	e.preventDefault();
					}
				}else if (param[0].noLogin == "N" && (COUNTRY_CODE == 'ca_en' || COUNTRY_CODE == 'ca_fr')) {
					//LGECI-115 start 
					var formValidateResult = $('#caForm').checkValidation({trigger:true});					
					if(formValidateResult){
						var caformJson = $("#caForm").serializeArray();						
						$.each(caformJson,function(key,value) {
							formData.append(caformJson[key].name,caformJson[key].value);
						});						
						formSubmit();
					}else{
						$('body').trigger('ajaxLoadEnd');
						isRun = false;
					}
					//LGECI-115 end
				}else{
					// LGEGMC-5323 start
					if(document.getElementById('customizedCaptcha') ==  null || document.getElementById('customizedCaptcha') == undefined ){
						if( !!$('#g-sitekey').val() && $("#useNewCaptchaView").val() == "N"){
							var reCaptcha_Key = $('#g-sitekey').val();
				        	grecaptcha.enterprise.ready(function() {
				        		grecaptcha.enterprise.execute(reCaptcha_Key, {action: $("#recaptchaPageType").val()}).then(function(token) {
				        			$("#g-recaptcha").val(btoa(token));
				        			formData.set("g-recaptcha",$("#g-recaptcha").val());
									formSubmit();
				        		});
				        	});
						}else if( !!$('#g-recaptcha').val() && $("#useNewCaptchaView").val() == "Y"){
							formData.set("g-recaptcha",$("#g-recaptcha").val());
							formSubmit();
						}else{
							formSubmit();
						}
					}
					else if(captcha.validation() != false) {
						formSubmit();
					}
					// LGEGMC-5323 end
				}
				
				function formSubmit(){
					// LGEAU-558
					if (COUNTRY_CODE == 'au' && document.querySelector('.signup-wrap')) {
						$('body').trigger('ajaxLoadBefore');
					}
					// LGEAU-558 End
					
					$.ajax({
						url: $optionForm.data('url'),
						type: 'post',
						data: formData,
						async: false,
						dataType: 'json',
						enctype: 'multipart/form-data',
						processData: false,
						contentType: false,
						beforeSend: function() {
							if ($proccessingArea.length && productType == 'b2b') {
								$proccessingArea.find('.processing-result .current').html(index + 1);
							}
						},
						success: function(data) {
							if (data.result || (!data.result && productType == 'b2b' && data.error.code == 'validation' && $proccessingArea.length)) {
								// LGEITF-597 start
								if( data.bvEncryptedEmail != undefined){
									 $("input[name=bvEncryptedEmail]").val(data.bvEncryptedEmail);
									 $("input[name=bvEncryptionKeyId]").val(data.bvEncryptionKeyId);
								}
								// LGEITF-597 end
								
								data.seqNo && (item.seqNo = data.seqNo);
								item.file && delete item.file;
								/* LGECI-687 start */
								for (var key in item) {
									if(key.indexOf("fileValue")!= -1){
										delete item[key];
									}
								}
								/* LGECI-687 end */
								item.successFlag = data.result;
								submitArr.push($.param(item).replace(/&/gi, ','));
							
								if (param.length == index + 1) {
									$optionForm.find('input[name="submitData"]').val(submitArr.join('&&'));
									$optionForm.find('input:not([name="submitData"])').prop('disabled', true);
									//LGEPE-134
									$optionForm.find('select:not([name="submitData"])').prop('disabled', true);
									
									if (productType == 'b2b' && $optionForm.data('b2bAction')) { 
										console.log($optionForm.find('input[name="submitData"]').val())
										$optionForm.attr('action', $optionForm.data('b2bAction'));
									}
									window.dataLayer.push({
										        event: 'register_product_complete',
										        model: item.modelName
										});
									if (typeof _trackEvent == 'function' && typeof _dl !== 'undefined') {	//LGEHU-468
										_trackEvent(
												$.extend(_dl,{
													sale_model_code:item.modelName,
													page_event : {
														register_product_complete : true, 
													}
												})
											);
									}
									// LGEGMC-3469, LGEGMC-5141 Start
									if(salesForceUseFlag || salesForceRunV2){
										const eventName = salesForceRunV2 ? 'CsRegProductClicked' : 'ecrmCsRegisterProductClicked';
										console.log(eventName + ' insert');
										
										SalesforceInteractions.sendEvent({
											interaction: {
												name: eventName,
												eventType: eventName,
												ecrmUserId: USER_ID,
												ecrmLocaleCode: COUNTRY_CODE,
												ecrmProductId: autoNvl( $('input[name="modelCsSalesCode"]').val() )
											}
										})
									};
									// LGEGMC-3469, LGEGMC-5141 End 

									/* PJTERAP-1 Start, toast flag 추가 */
									if(registerFlag){
										var input = $("<input>").attr("type", "hidden").attr("name", "toastAreaFlag").val("Y");
										$optionForm.append($(input));
									}
									/* PJTERAP-1 End */
									
									// LGECS-449 start
									promotionPopup( data.mylgProductPromotionPopFlag, 2);
									
								} else {
									promotionPopup( data.mylgProductPromotionPopFlag, 1);
								}
								
								function promotionPopup( mylgProductPromotionPopFlag, type){
									if( mylgProductPromotionPopFlag == "Y"){
										var modelEligiblePromotion = $("#modelEligiblePromotion");
										
										$(modelEligiblePromotion).find(".prd-img img").attr("data-src", $("#modelImgUrl").val());
										$(modelEligiblePromotion).find(".prd-img img").attr("alt", $("#modelNumber_hidden_1").val());
																				
										modelEligiblePromotion.modal('show');
										
										modelEligiblePromotion.on("hidden.bs.modal",function(){
											callSubmit( type)
										});
										
										modelEligiblePromotion.on("click","a",function(){
											modelEligiblePromotion.modal('hide');
										});
									}else{
										callSubmit( type);
									}
								}
								
								function callSubmit( type){
									if( type == "1"){
										submitHandler(index + 1);
									}else{
										// LGEAU-558
										if (COUNTRY_CODE == 'au' && document.querySelector('.signup-wrap')) {
											// LGEITF-491 start
											$("#withSignUpForm").submit();
											// LGEITF-491 end
										} else {
											$optionForm.submit();
										}
										// LGEAU-558 End
									}
								}
								// LGECS-449 end
								
								// LGESG-477
								if( item.csMatchedModelCode != "" && item.csMatchedModelCode != "NOT_MATCHED" && item.modelStatusCode != "" && item.modelStatusCode != "SUSPENDED"){
									// LGEAU-122, LGEAU-558, LGEGMC-3094 start
									if( $("input[name=auLocaleCode]").val()  == "au"){
										var myEmail = $("input[name=myEmail]").val();
										var auNickName = $("input[name=auNickName]").val();
										
										if (document.querySelector('.signup-wrap')) {
											myEmail = $("input[name=emailAddr]").val();
											auNickName = $("input[name=firstName]").val();
										}
										
										BV.pixel.trackTransaction({
										  "orderId" : "",
										  "total" : "",
										  "items" : [
										    {
										      "sku" : item.modelNumber,
										      "name" : item.modelName,
											  "price" : "",
										      "quantity" : "1",
										      "productId" : (item.csMatchedModelCode=='NOT_MATCHED'?item.modelNumber:item.csMatchedModelCode), //(ExternalId in product feed)
										      "category" : "",
										    }
										    ],
										    //"email" : myEmail, //Optional PII parameters
										    "locale" : $("input[name=auJavaLocaleCode]").val(),
										    "nickname" : auNickName,
										    "encryptedEmail" : $("input[name=bvEncryptedEmail]").val(), //Optional PII parameters
											"encryptionKeyId" : $("input[name=bvEncryptionKeyId]").val() // LGEITF-597
										});
									}
									// LGEAU-122, LGEAU-558 End
									// LGECL-126 start
									else if( $("input[name=bvEncryptEmailFlag]").val() == "true"){
										BV.pixel.trackTransaction({
											  "encryptedEmail" : $("input[name=bvEncryptedEmail]").val(), //Optional PII parameters
											  "encryptionKeyId" : $("input[name=bvEncryptionKeyId]").val(),
											  "locale" : $("input[name=javaLocaleCode]").val(),
											  "nickname" : $("input[name=nickName]").val(),
											  "items" : [
											    {
											      "productId" : (item.csMatchedModelCode=='NOT_MATCHED'?item.modelNumber:item.csMatchedModelCode), //(ExternalId in product feed)
											      "productName" : item.modelName,
											    }
											  ]
										});
									}
									// LGECL-126, LGEGMC-3094 end
								}
							} else if (!data.result && data.error) {
								// LGECI-541 start
    							if(document.getElementById('customizedCaptcha') ==  null || document.getElementById('customizedCaptcha') == undefined){
    								if( !!$('#g-recaptcha').val() && $("#useNewCaptchaView").val() == "Y"){
    									reload_recaptcha_wrapper();
    								}
    							}
    							// LGECI-541 end
								
								if (data.error.code == 'system') {
									if (data.error.message) {
										$('body').trigger('ajaxLoadEnd');
	
										$('#errorAlert').find('.content-paragraph').html(data.error.message);
										$('#errorAlert').modal('show');
	
										$('#errorAlert').find('[data-dismiss="modal"]').on('click.close', function() {																								
											if ($proccessingArea.length && productType == 'b2b') {
												if (submitArr.length) {
													$optionForm.find('input[name="submitData"]').val(submitArr.join('&&'));
													optionForm.find('input:not([name="submitData"])').prop('disabled', true);
													productType == 'b2b' && $optionForm.attr('action', $optionForm.data('b2bAction'));
													$optionForm.submit();
												} else {
													location.reload(true);
												}
											} else {
												isRun = false;
											}
										});
									}
								} else if (data.error.code == 'validation') {
									for (var key in data.error) {
										if (key != 'code') {	
											var $field = $optionForm.find('input[name="' + key + '"]'),
												$block = $field.parents(".field-block");
											
											$block.addClass('error').find('.ajax-msg').text(data.error[key]).show().siblings().hide();
											$field.focus();
										}
									}
	
									$('body').trigger('ajaxLoadEnd');
									isRun = false;
								} else if(COUNTRY_CODE == 'au' && document.querySelector('.signup-wrap') && 
										typeof data.error.birthDate != 'undefined' && data.error.birthDate){
									var block = $('#birthDate').parents(".field-block");
									block.addClass('error');
									$('body').trigger('ajaxLoadEnd');
									showAndHideElements(block.find('.error-msg'), 'show', 'limitAge');
									$('#birthDate').focus();
									isRun = false;
								}
							}
						},
						error: function(request, status, error) {
							$('body').trigger('ajaxLoadEnd');
							isRun = false;
							//e.preventDefault();
						},
						complete: function(){
							
						}
					});
				}
				// LGECI-59 end
			};

			if ($listItem.length) {
				$listItem.each(function(index, item) {
					param.push($(item).data('option'));
				});
				
				checkFlag = true;
			} else {
				checkFlag = $optionForm.checkValidation({trigger:true});

				if (checkFlag) {
					paramArr = $.merge($inputArea.find('.comboboxForm').serializeArray(), $optionForm.serializeArray());
					
					$.each(paramArr, function(index, item) {
						tempParam[item.name] = item.value;
					});

					tempParam.modelName = $inputArea.find('.search-common-input').val();
					tempParam.imgUrl = $inputArea.find('.model-image').attr('src');
					// PJTEXTENDEDWTY-4
					tempParam['placePurchase'] = $('[name=placePurchase]').val();;
					tempParam['placePurchaseCode'] = $('[name=placePurchaseCode]').val();
					// PJTEXTENDEDWTY-4
					/* LGECI-687 start */
					$files = $optionForm.find('.replace-file-input').find('input:file');
					if($files.length > 1) {
						for (var j = 0; j < $files.length; j++) {
								var _file = $files.eq(j).get(0);
								if(_file.files[0]) {
									tempParam[_file.name] = _file.files[0];
								}
							} 
					}else{
						if ($optionForm.find('.replace-file-input').find('input[type="file"]')[0].files.length) {
							tempParam['file'] = $optionForm.find('.replace-file-input').find('input[type="file"]')[0].files[0];
						}
					}
					/* LGECI-687 end */	
					param.push(tempParam);
				}				
			}	
			
			if (checkFlag) {
				if (productType == 'b2b' && $proccessingArea.length) {
					$proccessingArea.show();
					$proccessingArea.siblings(':not(.guide)').hide();
					$proccessingArea.find('.processing-result .current').html(1);
					$proccessingArea.find('.processing-result .total').html(param.length);

					$('html, body').scrollTop($('.support-wrap').offset().top);
				} else {
					$('body').trigger('ajaxLoadBefore');
				}

				submitHandler(0);
			} else {
				isRun = false;
			}
			
			e.preventDefault();
		});
		$(document).on('change', 'input[type="file"]', function() {
			$(this).checkValidation();
		});
		// 200326 START 전호근 - 시리얼넘버 대문자 변환
		$(document).on('focusout', '[name="serialNumber"]', function(){
			$(this).val($(this).val().toUpperCase());
		});
		// 200326 END 전호근 - 시리얼넘버 대문자 변환
		/* LGEPE-143, LGEPE-247 Start */
		$('select[name="promoter"]').on('change', function(){
			var id = $(this).prev().attr('for').replace('promoter_', '');
		    var $promoterCode = $('#promoterCode_'+id);
		    var $promoterCodeLabel = $('label[for="promoterCode_'+id+'"]');
			
		    $promoterCode.parent().removeClass('error')
		    if($(this).find('option:selected').attr('class') == 'mandatory'){
		    	$promoterCode.attr('required', true);
		        !!$promoterCodeLabel.find('.require').length ? '' :  $promoterCodeLabel.append('<span class="require">*<span class="sr-only">Required field</span></span>');
		    }else{        
		    	$promoterCode.attr('required', false);
		    	$promoterCodeLabel.find('.require').remove();
		    }
		});
		/* LGEPE-143, LGEPE-247 End */
		/* PJTGPEMP-21 Start */
		$(document).on('change',' .infoOpen', function() {
		    if($(this).prop('checked') == true){
		        $(this).parents('p').find('.chk-info').attr('style','display');
		    }else{
		        $(this).parents('p').find('.chk-info').attr('style','display:none;');
		    }
		});
		/* PJTGPEMP-21 End */
	}
	$(document).ready(function() {
		productSpaceInit();
		productListInit();
		eventhandler();
	});
	
	function showAndHideElements(targetObject, toggle, targetElement) {
		targetObject[toggle == 'show' ? 'show' : 'hide']();

		targetObject.children().each(function (index, item) {
			var className = $(item).attr('class');
			if (className == targetElement) {
				$(item)[toggle == 'show' ? 'show' : 'hide']();
			} else {
				$(item).hide();
			}
		});
	}
	
})();